import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import api from './api/api';
import storeJs from 'storejs';
import moment from 'moment';
import common from './utils/common';
import cookies from 'js-cookie';
import ElementUI from 'element-ui';
import VueClipboard from 'vue-clipboard2';
import './assets/css/style.css'
import 'element-ui/lib/theme-chalk/index.css';

VueClipboard.config.autoSetContainer = true;

Vue.use(ElementUI);
Vue.use(VueClipboard);

Vue.prototype.$api = api;
Vue.prototype.$common = common;
Vue.prototype.$cookies = cookies;
Vue.prototype.$storeLocal = storeJs;
Vue.config.productionTip = false;

Vue.filter('dateFormat',function (dataStr,pattern = "YYYY-MM-DD HH:mm:ss") {
  return moment(dataStr).format(pattern);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
